import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import history from "../../History";
import { Modal } from "antd";

import {
  MILLISECONDS_SHOW_IDLE_USER,
  SECONDS_DESTROY_SESSION,
  sendNotification
} from "../../utils";
import { refreshToken } from "../../actions/AuthAction";
import React, { Component } from "react";
import IdleTimer from "react-idle-timer";

export class RefreshToken extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false
    };
    this.idleTimerRef = null;
    this.timer = null;
  }

  OnIdle = () => {
    const { isUploading } = this.props;
    if (!isUploading) {
      this.launchModal();
    } else {
      this.idleTimerRef.reset();
    }
  };

  launchModal = () => {
    const { intl, token } = this.props;
    let secondsToClose = SECONDS_DESTROY_SESSION;
    let modal = Modal.warning({
      title: intl.formatMessage({ id: "are_you_there" }),
      content:
        intl.formatMessage({ id: "your_session_will_be_closed_in" }) +
        " " +
        secondsToClose +
        " " +
        intl.formatMessage({ id: "seconds" }),
      okText: intl.formatMessage({ id: "im_here" }),
      onOk: () => {
        clearInterval(this.timer);
        modal.destroy();
        this.props.refreshToken(token.refreshToken);
      }
    });
    this.timer = setInterval(() => {
      secondsToClose -= 1;
      modal.update({
        content:
          intl.formatMessage({ id: "your_session_will_be_closed_in" }) +
          " " +
          secondsToClose +
          " " +
          intl.formatMessage({ id: "seconds" })
      });

      if (secondsToClose === 0) {
        clearInterval(this.timer);
        modal.destroy();
        sendNotification(
          "inactive",
          intl,
          intl.formatMessage({ id: "your_session_has_expired" })
        );
        history.push("/logout");
      }
    }, 1000);
  };

  render() {
    return (
      <React.Fragment>
        <IdleTimer
          timeout={MILLISECONDS_SHOW_IDLE_USER}
          onIdle={this.OnIdle}
          ref={ref => {
            this.idleTimerRef = ref;
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    isUploading: state.client.isUploading,
    exp: state.authUser.exp,
    token: {
      accessToken: state.authUser.token.accessToken,
      refreshToken: state.authUser.token.refreshToken
    },
    error: state.authUser.error
  };
};

const mapDispatchToProps = {
  refreshToken
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RefreshToken))
);
